/* eslint 'no-redeclare': 'off', no-unused-vars: 'off' */
import React,{Component} from "react";
import { connect } from "react-redux";
import { Col, Button, FormGroup, Label } from 'reactstrap'
import { closeModalPopUp } from '../../../../action/modalStateAction';
import {PostLaborDetails, EditLaborDetails,PostPMLaborDetails, EditPMLaborDetails } from '../../../../action/workorderAction';
import Flatpickr from 'react-flatpickr';
import {Icon} from 'semantic-ui-react';


let SelectedworkOrderId = 0, IsEdit = false, date, IsPMDetail = false;

const ErrorSign = {
    color: '#D42D27',
    paddingLeft: '8px',
    paddingTop: '0px',
    paddingRight: '14px',
    width: '22px',
    height: '22px',
    top: '406px',
    left: '959px'
};

const RequiredText = {
    'color': '#D42D27', 
    'font-style': 'italic', 
    'font-size': '10px', 
    'font-family': 'Lato' 
};

const PaddingContainer = {
    paddingLeft:'10px',
    paddingTop:'10px'
};

const ErrorPadding = {
    'color': '#D42D27',
    'font-family': 'Lato',
    'font-style': 'italic',
    'border': '2px solid #D42D27',
    'height': '40px',
    'padding': '10px',
    'float': 'left',
    'background-color': '#FFFFFF',
    'font-size': '13px',
    'margin-bottom': '0px',
    'margin-top':'-5px'
};

class AddLaborForm extends Component {

    componentWillMount() {
        SelectedworkOrderId = this.props.ParentToChildData[0];
        IsEdit = this.props.ParentToChildData[1];
        IsPMDetail = this.props.ParentToChildData[3];
        if (IsEdit) {
            date = (this.props.ParentToChildData[2][0].dateOfService !== "1753-01-01T00:00:00") ? new Date(this.props.ParentToChildData[2][0].dateOfService): null;
            this.setState({
                LaborDetails: this.props.ParentToChildData[2],
                date: date
            });
        }
    }
    constructor(props){
        super(props);
        this.state ={
            error:{
                laborname: false,
                regularhours: false,
                overtime: false,
            },
            isError: false,
            date:null,
            LaborDetails: []
        };
        this.CloseModal = this.CloseModal.bind(this);
        this.SaveLaborDetails = this.SaveLaborDetails.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(date) {
        this.setState({
            date: new Date(date)
        });
    }

    CloseModal(){
        this.refs.New_Labor_Name.value = "";
        this.refs.New_Labor_Reghrs.value = "";
        this.refs.New_Labor_Overtime.value = "";
        IsEdit = false;
        this.setState({date : null});
        this.props.closeModalPopUp("close");    
    }

    SaveLaborDetails (){
        var IsValid = true;
        var laborname = this.refs.New_Labor_Name.value;
        var labordos = this.state.date;
        var laborreghrs = this.refs.New_Labor_Reghrs.value;
        var laborovertime = this.refs.New_Labor_Overtime.value;
        var DataOfService = "01/01/1753";
        
        let invalid_regularhours = (laborreghrs !== "" && Number.isNaN(Number(laborreghrs))) ? true : false;
        let invalid_overtime = (laborovertime !== "" && Number.isNaN(Number(laborovertime))) ? true : false;

        if(laborname === "" || invalid_regularhours || invalid_overtime){
            IsValid = false;
            this.setState({error: {
                laborname : (laborname !== "") ? false : true ,
                regularhours: (laborreghrs !== "" && invalid_regularhours) ? true : false,
                overtime: (laborovertime !== "" && invalid_overtime) ? true : false,
            }, isError : true});
        }

        if(IsValid){
            if(labordos !== null){
                let twoDigitMonth = (this.state.date.getMonth() + 1).toString().length > 1 ? (this.state.date.getMonth() + 1) : "0" + (this.state.date.getMonth() + 1).toString();
                let twoDigitDay = this.state.date.getDate().toString().length > 1 ? this.state.date.getDate() : "0" + this.state.date.getDate().toString();
                DataOfService = twoDigitMonth + "/" + twoDigitDay + "/" + this.state.date.getFullYear();
            } 

            if(!IsPMDetail){
                var data = {
                    "DateOfService": DataOfService,
                    "UserName":laborname,
                    "RegularHour":laborreghrs === "" ? 0 : laborreghrs,
                    "TimeDuration": laborovertime === "" ? 0 : laborovertime,
                    "WorkOrderID":SelectedworkOrderId
                }
                if(IsEdit){
                    var laborId = this.state.LaborDetails[0].workOrderLaborID;
                    this.props.EditLaborDetails(laborId,data);
                }else{
                    this.props.PostLaborDetails(data);
                }
              }
              else{
                var data = {
                    "DateOfService": DataOfService,
                    "UserName":laborname,
                    "RegularHour":laborreghrs === "" ? 0 : laborreghrs,
                    "TimeDuration": laborovertime === "" ? 0 : laborovertime,
                    "PMId":SelectedworkOrderId
                }
                if(IsEdit){
                    var laborId = this.state.LaborDetails[0].laborId;
                    this.props.EditPMLaborDetails(laborId,data);
                }else{
                    this.props.PostPMLaborDetails(data);
                }
              }
            this.props.closeModalPopUp("close"); 
        }
    }        

    render(getLabels){
        let modal = null, ErrorMessage;
        let label = this.props.getLabels;
        let Header = "Add Labor";
        let lName, lDate, lRegularHr, lOverTime;    //eslint-disable-line

        //validations
        if(this.state.isError){
            ErrorMessage = <p style={ErrorPadding} >
                            <Icon name='exclamation triangle' style={ErrorSign} />
                            <b>Please correct all errors before continuing.</b>
                           </p>
        }

        if(IsEdit && this.state.LaborDetails != null && this.state.LaborDetails.length){
            lName = this.state.LaborDetails[0].userName;
            lDate = this.state.LaborDetails[0].dateOfService;
            lRegularHr = this.state.LaborDetails[0].regularHour;
            lOverTime = this.state.LaborDetails[0].timeDuration;
            Header = "Edit Labor";
        }

        modal = <div>            
                    <p className='workordermainheaderlbl' style={PaddingContainer}>{Header}
                        <span className="wo_employee_closeIcon" onClick={()=>{this.CloseModal()}}>X</span>
                    </p>
                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                    <div className="passwordContainer">
                        <FormGroup row style={{marginBottom:(this.state.error.laborname) ? "0px":"10px"}}>
                            <Col sm={{size:6}}>
                                <label className={(this.state.error.laborname) ? "errortext wo_headerlabel" :"wo_headerlabel"}>{label['WorkOrders.AddLaborName.Text'] !== undefined ? label['WorkOrders.AddLaborName.Text']+"*": "Name*"}</label>
                                <input ref='New_Labor_Name' className={(this.state.error.laborname) ? "errorhighlight wo_details_textbox": "wo_details_textbox"} defaultValue={lName} />
                                <span hidden={!this.state.error.laborname}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                        <Label style={RequiredText}><b>An entry is required</b></Label></span>
                            </Col>
                        </FormGroup>
                        <FormGroup row >
                            <Col sm={{size:6}}>
                                <label className="wo_headerlabel">{label['WorkOrders.AddLaborDateofService.Text'] !== undefined ? label['WorkOrders.AddLaborDateofService.Text'] : "Date of Service"}</label>
                                <Flatpickr value={this.state.date} ref="New_Labor_DOS" onChange={this.handleChange} className="wo_details_textbox"/>  
                            </Col>                  
                        </FormGroup>
                        <FormGroup row style={{marginBottom:(this.state.error.regularhours) ? "0px":"10px"}}>
                            <Col sm={{size:6}}>
                                <label className={(this.state.error.regularhours) ? "errortext wo_headerlabel" :"wo_headerlabel"}>{label['WorkOrders.AddLaborRegularHours.Text'] !== undefined ? label['WorkOrders.AddLaborRegularHours.Text'] : "Regular Hours"}</label>
                                <input ref='New_Labor_Reghrs' className={(this.state.error.regularhours) ? "errorhighlight wo_details_textbox": "wo_details_textbox"} defaultValue={lRegularHr} />
                                <span hidden={!this.state.error.regularhours}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                        <Label style={RequiredText}><b>This field can only contain numeric values</b></Label></span>
                            </Col>
                        </FormGroup>
                        <FormGroup row style={{marginBottom:(this.state.error.overtime) ? "0px":"10px"}}>
                            <Col sm={{size:6}}>
                                <label className={(this.state.error.overtime) ? "errortext wo_headerlabel" :"wo_headerlabel"}>{label['WorkOrders.AddLaborOvertime.Text'] !== undefined ? label['WorkOrders.AddLaborOvertime.Text']: "Overtime"}</label>
                                <input ref='New_Labor_Overtime' className={(this.state.error.overtime) ? "errorhighlight wo_details_textbox": "wo_details_textbox"} defaultValue={lOverTime} />
                                <span hidden={!this.state.error.overtime}><Icon name='exclamation triangle' style={ErrorSign} /><br/>
                                            <Label style={RequiredText}><b>This field can only contain numeric values</b></Label></span>
                            </Col>
                        </FormGroup>
                    </div>
                    <div style={{ borderTop:'1px solid #FFFFFF'}}/>
                    <div style={{marginTop:'10px', marginBottom:'25px'}}>
                        <span className="workorderlbl-noentry" style={{paddingLeft:'10px'}}>*required fields </span>
                        <div style={{float:'right'}}>      
                            {ErrorMessage}  
                            <Button className="wo_cancel_btn"  style={{'float': 'right', 'margin-left': '6px','margin-right':'10px' }} onClick={()=>{this.CloseModal()}} >CANCEL </Button>
                            <Button className="wo_save_btn" style={{'float': 'right', 'margin-left': '6px'}} onClick={()=>{this.SaveLaborDetails()}} >FINISH </Button>
                        </div>
                    </div>
                </div>               
                
        return (
            <div>
                {modal}
            </div>
        );
    }
};
const mapStateToProps = state =>{
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference
    };
};
const mapDispatchToProps = dispatch =>{
    return{
        closeModalPopUp: (modaldata) => dispatch(closeModalPopUp(modaldata)),
        PostLaborDetails : (data) => dispatch(PostLaborDetails(data)),
        EditLaborDetails : (Id, data) => dispatch(EditLaborDetails(Id, data)),
        PostPMLaborDetails : (data) => dispatch(PostPMLaborDetails(data)),
        EditPMLaborDetails : (Id, data) => dispatch(EditPMLaborDetails(Id, data))
    };
};

export default connect(mapStateToProps,mapDispatchToProps) (AddLaborForm);